import React, { useState } from "react";
import ReviewPurchaseDetails from "./ReviewPurchaseDetails";
const ReviewPurchase = ({
  poNumber,
  setPoNumber,
  textareaValue,
  setTextareaValue,
  currentFileRequired,
  translationKey,
}) => {
  const [isTextareaValid, setIsTextareaValid] = useState(true);

  const handleInputValueChange = (e) => {
    const { value } = e.target;
    setPoNumber({ ...poNumber, poenter: value.slice(0, 22) });
  };

  const handleTextareaValueChange = (e) => {
    let { value } = e.target;
    if (value.length > 255) {
      value = value.slice(0, 255);
    }
    setIsTextareaValid(value.length <= 255);
    setTextareaValue({ ...textareaValue, comment: value });
  };

  const characterCount = textareaValue?.comment
    ? textareaValue?.comment?.length
    : 0;
  const remainingCharacters = 255 - characterCount;

  return (
    <>
      <div className="checkout-common-shadow-wrapper">
        <div className="checkout-sub-card-header">
          <h2 className="checkout-sub-header-title">
            3. {translationKey(currentFileRequired["REVIEW_PURCHASE_HEADER"])}
          </h2>
        </div>
        <div className="po-number">
          <label>
            {translationKey(currentFileRequired["PO_NUMBER_LABEL"])}
          </label>
          <input
            type="text"
            value={poNumber.poenter}
            placeholder={translationKey(currentFileRequired["ENTER_PO_NUMBER"])}
            name="ponumber"
            onChange={handleInputValueChange}
          />
        </div>
        <div className="special-instructions">
          <label>
            {translationKey(currentFileRequired["SPECIAL_INSTRUCTIONS_LABEL"])}
          </label>
          <textarea
            value={textareaValue.comment}
            onChange={handleTextareaValueChange}
            placeholder={translationKey(
              currentFileRequired["DESCRIBE_YOUR_REQUEST"]
            )}
          />
          {!isTextareaValid && (
            <p>
              {translationKey(currentFileRequired["CHARACTER_LIMIT_MESSAGE"])}
            </p>
          )}
          <div className="characters-left">
            {translationKey(currentFileRequired["CHARACTERS_LEFT"])}:{" "}
            {remainingCharacters}
          </div>
        </div>
        <ReviewPurchaseDetails
          currentFileRequired={currentFileRequired}
          translationKey={translationKey}
        />
      </div>
    </>
  );
};
export default ReviewPurchase;
